<template lang="html">
  <div class="main-container">
    <section class="double-top-pad">
      <div class="top-block"></div>

      <div class="container">
        <div class="row">
          <div class="col-md-6 col-md-offset-3">
            <h1 v-html="about.title"></h1>
            <p
              class="page-paragraph"
              v-for="(p, index) in about.body"
              v-html="p"
            ></p>
            <div class="camel"><img src="static/img/common/camel.png" /></div>

            <router-link :to="'/'">
              <div class="block-button back-button">
                <div class="mybutton-up">BACK</div>
                <div class="mybutton-down">BACK</div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <section class="name-section name-section-small">
      <div class="name-section-inner name-section-inner-black"></div>
    </section>
  </div>
</template>

<style type="text/css"></style>

<script>
import { about } from "../../content.json";
// var dataURL = 'https://api.ralphandco.com/updates'
import { commontools } from "../mixins/Styling";

export default {
  mixins: [commontools],
  name: "about",
  watch: {
    "$route.name": function (id) {
      window.scrollTo(0, 0);
    },
  },
  data() {
    return {
      about,
    };
  },
  methods: {},
  created: function () {},
  mounted: function () {
    window.scrollTo(0, 0);
    // setTimeout(() => {
    //   this.manageWidows()
    // }, 100)
  },
  components: {},
};
</script>
